module.exports = __webpack_public_path__ + "static/img/beta_bg_08.b8c723f3.svg";